<template>
  <div class="home">
    <router-view></router-view>
    <div class="tabs">
      <!-- <div class="kong"></div> -->
      <router-link tag="div" class="course" to="/home/mytask" replace>
        <div>
          <div class="minds">
            <div class="icon"></div>
          </div>
          我的任务
        </div>
      </router-link>
     
      <router-link tag="div" class="create" to="/home/task" replace>
        <div>
          <div class="minds">
            <div class="icon"></div>
          </div>
          任务大厅
        </div>
      </router-link>
       <router-link tag="div" class="resume" to="/home/interview" replace>
        <div>
          <div class="minds">
            <div class="icon"></div>
          </div>
          简历筛选
        </div>
      </router-link>
      <router-link tag="div" class="me" to="/me" replace>
        <div>
          <div class="minds">
            <div class="icon"></div>
          </div>
          个人中心
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
    data() {
    return {
      active: 0,
      icon: {
        active: 'https://img.yzcdn.cn/vant/user-active.png',
        inactive: 'https://img.yzcdn.cn/vant/user-inactive.png',
      },
    };
  },
  created() {
  },
  components: {
  },
  methods: {
    gomy(s) {
      if(s ===1) {
        this.$router.replace({ path: 'mytask' })
      } else if(s === 2) {
        this.$router.replace({ path: 'task' })
      }
    }
  }
}
</script>

<style lang="scss">
.home {
  height: 100%;
}
.van-hairline--top-bottom {
  height: 65px !important;
}
.tabs{
  border-top: 1px solid #ccc;
  text-align: center;
  position: fixed;
  width: 100%;
  display: flex;
  height: 65px;
  align-items: center;
  left: 50%;
  justify-content: space-between;
  transform: translateX(-50%);
  bottom: 0;
  z-index: 99;
  background: url(../../assets/image/foot.png);
  background-size: 100%;
  background-color: white;
  // box-shadow:0px 1px 6px 0px rgba(0,0,0,0.14);
  // border-radius: size(60);
  padding: 0 size(28);
  .kong {
    width: 15%;
    height: 100%;
  }
  .icon{
    width: 48px;
    height: 34px;
    transform: scale(1.10);
  }
  .name{
    font-size: 10px;
    color: #ABABAA;
  }
  .minds {
    display: flex;
    justify-content: center;
    margin-bottom: 6px;
  }
  .me{
    flex: 1;
    display: flex;
    justify-content: center;
    .icon{
      width:18px;
      height: 18px;
      background-image: url('~@/assets/image/tab-me.png');
      background-size: 100% 100%;
    }
    &.router-link-active .icon{
      width: 24px;
      height: 24px;
      background-image: url('~@/assets/image/tab-me_active.png');
    }
  }
  .router-link-active .name{
    color: #000!important;
  }
  .course{
    flex: 1;
    display: flex;
    justify-content: center;
    .icon{
      width: 18px;
      height: 18px;
      background-image: url('~@/assets/image/tab-hall.png');
      // background-image: url('@/src/assets/image/home.png');
      background-size: 100% 100%;
      position: relative;
    }
    &.router-link-active .icon{
      width: 24px;
      height: 24px;
      background-image: url('~@/assets/image/tab-hall_active.png');
    }
  }
  .create{
    flex: 1;
    display: flex;
    justify-content: center;
    .icon{
      width: 18px;
      height: 18px;
      background-image: url('~@/assets/image/tab-home.png');
      background-size: 100% 100%;
      position: relative;
    }
    &.router-link-active .icon{
      width: 24px;
      height: 24px;
      background-image: url('~@/assets/image/tab-home_active.png');
    }
    .name{
    }
  }
  .resume {
    flex: 1;
    display: flex;
    justify-content: center;
     .icon{
      width: 18px;
      height: 18px;
      background-image: url('~@/assets/image/tab-resume.png');
      background-size: 100% 100%;
      position: relative;
    }
    &.router-link-active .icon{
      width: 24px;
      height: 24px;
      background-image: url('~@/assets/image/tab-resume_active.png');
    }
  }
  .router-link-active .lminds{
    width: 40px;
    padding-bottom: 10px;
    border-bottom: 4px solid #4464eb;
  }
}
</style>
